module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "citic-page-header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.pageTitle))]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "search-box"
  }, [_vm._t("search-box")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-69ea4ee7!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/ThePageHeader.vue
// module id = 466
// module chunks = 11